<template>
  <div class="filter-row">
    <div
      v-for="(option, index) in options"
      :key="index"
      class="filter-item"
      :class="{ 'is-active': option.value === modelValue }"
      @click="$emit('update:modelValue', option.value)"
    >
      <div>
        {{ $t(option.label) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["modelValue"],
  data: () => ({
    options: [
      { value: null, label: "all_ceremonies" },
      { value: 5, label: "ceremony_1_2026" },
      { value: 6, label: "ceremony_2_2026" },
      { value: 7, label: "ceremony_3_2026" },
      { value: 8, label: "ceremony_4_2026" },
    ],
  }),
};
</script>

<style lang="scss">
.filter-row {
  display: none;

  @media (min-width: 1250px) {
    display: flex;
  }
}

.filter-item {
  padding: 10px 30px;
  border-right: 2px solid #000;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:first-child {
    border-left: 2px solid #000;
  }

  &.is-active {
    background: #6d00cf !important;
    color: #fff;
  }

  &:hover {
    background: #00a0a4;
    color: #fff;
  }
}
</style>
